import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import MemberDashboard from './MemberDashboard';
import VendorDashboard from './VendorDashboard';
import PlatformDashboard from './PlatformDashboard';

export default function Dashboard() {
  const { role, loading } = useAuth();

  if (loading || !role) {
    return (
      <div style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', color: 'var(--ink-soft)' }}>
        <span className="mono" style={{ fontSize: 13, letterSpacing: '0.14em', textTransform: 'uppercase' }}>Loading…</span>
      </div>
    );
  }

  return (
    <Routes>
      {role === 'platform' && <Route path="*" element={<PlatformDashboard />} />}
      {role === 'vendor'   && <Route path="*" element={<VendorDashboard />} />}
      {role === 'member'   && <Route path="*" element={<MemberDashboard />} />}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
